export enum WCCSliderItemState {
    justCreated = 0,
    pending = 1,
    active = 2
}